export default "__VITE_ASSET__DWcL$xLI__"